import { memo, useState } from 'react';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Input, message } from 'antd';

const Index = (props) => {
  const { paginationInfo, showTotalInfo, showJumpBtn } = props;
  const { total, currentPage, prevHref, paginationPages, countPage, nextHref } = paginationInfo;
  const [inputValue, setInputValue] = useState(null);

  const changePage = (e, page) => {
    e.preventDefault(); // 阻止a标签默认跳转事件
    if (currentPage === page || page === '...') {
      return false;
    }
    const regex = /^[1-9]\d*$/;
    if (!page || !regex.test(page)) {
      message.error('页码必须是数字');
      return false;
    }
    if (Number(inputValue) > Number(countPage)) {
      message.error('超过最大页码');
      return false;
    }

    props?.changePagination(page);
  };

  const changeInput = (e) => {
    setInputValue(Number(e.target.value) > 50 ? 50 : e.target.value);
  };

  return (
    <div className={'flex'}>
      <ul data-spm="pg" className={'flex flex-1 items-center justify-center'}>
        {currentPage > 1 && (
          <li
            onClick={(e) => changePage(e, currentPage - 1)}
            className={'mr-[8px] flex size-[32px] cursor-pointer items-center justify-center'}
          >
            <a ignore-spm href={prevHref} className={'hover:text-[#1677FF]'}>
              <LeftOutlined />
            </a>
          </li>
        )}
        {(paginationPages || []).map((item, index) => {
          return (
            <li
              key={index}
              onClick={(e) => changePage(e, item.page)}
              className={'mr-[8px] flex size-[32px] items-center justify-center text-[#000000]'}
            >
              {item.page === '...' ? (
                <>...</>
              ) : (
                <a
                  ignore-spm
                  href={item.href}
                  className={`flex size-[32px] text-[14px] ${currentPage === item.page ? 'bg-white' : ''} hover:bg-white cursor-pointer items-center justify-center text-[#000000] hover:rounded-[6px]  hover:border  hover:border-solid  hover:border-[#1677FF]  hover:text-[#0093E6] ${currentPage === item.page ? 'rounded-[6px] border border-solid border-[#1677FF] text-[#0093E6]' : ''}`}
                >
                  {item.page}
                </a>
              )}
            </li>
          );
        })}
        {countPage > currentPage && (
          <li
            className={'flex size-[32px] cursor-pointer items-center  justify-center'}
            onClick={(e) => changePage(e, currentPage + 1)}
          >
            <a ignore-spm className={'hover:text-[#1677FF]'} href={nextHref}>
              <RightOutlined />
            </a>
          </li>
        )}
      </ul>
      {(showTotalInfo || showJumpBtn) && (
        <div className={'flex items-center justify-center text-[#000000]'}>
          {showTotalInfo && (
            <>
              <span>共{countPage}页</span>，<span>{total}条记录</span>
            </>
          )}
          {showJumpBtn && (
            <>
              <span className={'pl-[15px]'}>
                <span className={'pr-[10px]'}>到</span>
                <Input
                  type="text"
                  className={'!w-[40px]'}
                  size={'small'}
                  value={inputValue}
                  onChange={(e) => changeInput(e)}
                />
                <span className={'pl-[10px] pr-[10px]'}>页</span>
              </span>
              <div
                onClick={(e) => changePage(e, inputValue)}
                className={'translate-y-[1px] cursor-pointer hover:text-[#1677FF]'}
              >
                确定
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(Index);
